<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="social_15707753 1">
<g id="Group">
<path id="Vector" d="M10 20.5C4.478 20.5 0 16.022 0 10.5C0 4.978 4.478 0.5 10 0.5C15.522 0.5 20 4.978 20 10.5C20 16.022 15.522 20.5 10 20.5Z" fill="#0078B5"/>
<g id="Group_2">
<g id="Group_3">
<path id="Vector_2" d="M3.68405 8.2459H6.34205V16.7999H3.68405V8.2459ZM5.01405 3.9939C5.86405 3.9939 6.55405 4.6839 6.55405 5.5359C6.55405 6.3879 5.86405 7.0779 5.01405 7.0779C4.16205 7.0779 3.47205 6.3879 3.47205 5.5359C3.47005 4.6859 4.16005 3.9939 5.01405 3.9939Z" fill="white"/>
<path id="Vector_3" d="M8.01013 8.24598H10.5601V9.41398H10.5961C10.9501 8.74198 11.8161 8.03198 13.1121 8.03198C15.8041 8.03198 16.3021 9.80398 16.3021 12.106V16.8H13.6441V12.642C13.6441 11.648 13.6261 10.374 12.2621 10.374C10.8781 10.374 10.6661 11.454 10.6661 12.57V16.802H8.01013V8.24598Z" fill="white"/>
</g>
</g>
</g>
</g>
</svg>
